import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';

import { currentUserACL } from 'selectors/auth.selector';

const AdminRoute = ({ element }) => {
  const userACL = useSelector((state) => {
    return currentUserACL(state);
  });
  const isAdmin = userACL.admin || false;

  return isAdmin ? element : <Navigate to="/" replace />;
};

AdminRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default AdminRoute;
